<template>
  <v-radio-group v-model="selectedProgram" @change="chooseProgram">
    <ul class="programs-list m-0 d-flex flex-column">
      <SingleProgram
        v-for="program in programs"
        :key="program.id"
        :program="program"
        @choose-selected-program="chooseSelectedProgram"
        ref="program"
      />
    </ul>
  </v-radio-group>
</template>

<script>
import GlobalMixin from "../../GlobalMixin";
import SingleProgram from "./SingleProgram.vue";

export default {
  name: "ProgramList",
  mixins: [GlobalMixin],
  components: { SingleProgram },
  props: {
    programs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedProgram: null,
    };
  },
  methods: {
    /**
     * Selected a program if exists in store
     * @param program object
     */
    chooseSelectedProgram(program) {
      this.selectedProgram = program;
    },
    /**
     * Choose a progam and send its ID to store if it's eligible for a free session
     * Remove selection if user already reserved a free session before
     * @param program object
     */
    chooseProgram(program) {
      const body = {
        program: program.id,
        tutor: this.$route.params.id,
      };
      this.axios
        .post(
          `${process.env.VUE_APP_APIEndPoint}reserve/free-trial-eligibility/`,
          body,
          this.headers
        )
        .then((res) => {
          if (res.data.success)
            return this.$store.dispatch("saveProgram", program);
          this.showAlert(res.data.data.message);
        })
        .catch((err) => {
          this.selectedProgram = null;
          document
            .querySelectorAll(".active")
            .forEach((p) => p.classList.remove("active"));
          this.formatErrors(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.programs-list {
  list-style: none;
  gap: 16px;
}
</style>
